import React, { FC } from 'react';
import { TertiaryButton } from '@bigid-ui/components';
import { LanguageContainer } from '../../../../state/languageContainer';
import { BigidChevronLeftIcon } from '@bigid-ui/icons';
import { StyledMobileStepNavigation } from './MobileStepNavigationStyles';

type MobileStepNavigationPropsType = {
  onClick: () => void;
  activeStep: number;
  totalStep: number;
};

export const MobileStepNavigation: FC<MobileStepNavigationPropsType> = ({ onClick, activeStep, totalStep }) => {
  const { BigIdMeTranslate, BigIdMeTranslateWithNode } = LanguageContainer.useContainer();

  return (
    <StyledMobileStepNavigation>
      <div>
        {activeStep > 0 && (
          <TertiaryButton
            onClick={onClick}
            startIcon={<BigidChevronLeftIcon />}
            aria-label="Back"
            size="small"
            bi={{ eventType: 'mobile_submit_request_back' }}
            text={BigIdMeTranslate('consumer_web_back')}
          />
        )}
      </div>
      <div>
        {BigIdMeTranslateWithNode('consumer_web_active_step', [
          { key: 'current', value: activeStep + 1 },
          { key: 'total', value: totalStep },
        ])}
      </div>
    </StyledMobileStepNavigation>
  );
};
